<template>
    <div class="d-flex flex-center  bgi-size-cover bgi-no-repeat" :class="{'vh100' : (step == 1  || step ==4) }" 
			v-bind:style="{'background-image': 'url(' + bg_image + ')' }">
        <div class="">
        <div class="container pt-9" style="max-width: 1200px">
            <div class="card card-custom">
				<div class="card-body p-0">
					<div class="wizard wizard-5 d-flex flex-column flex-lg-row flex-row-fluid" id="kt_wizard" data-wizard-state="first">
						<div class="wizard-aside bg-white d-flex flex-column flex-row-auto w-100 w-lg-300px w-xl-400px w-xxl-400px">
							<div class="d-flex flex-column-fluid flex-column px-5">
								<div class="wizard-nav d-flex d-flex justify-content-center pt-10 pt-lg-20 pb-5">
									<div class="wizard-steps">
										<div class="wizard-step" data-wizard-type="step" :data-wizard-state="getState(1)">
											<div class="wizard-wrapper">
												<div class="wizard-icon">
													<i class="wizard-check ki ki-check"></i>
													<span class="wizard-number">1</span>
												</div>
												<div class="wizard-label">
													<h3 class="wizard-title">Agreement</h3>
													<div class="wizard-desc">Agree to terms and conditions</div>
												</div>
											</div>
										</div>

										<div class="wizard-step" data-wizard-type="step" :data-wizard-state="getState(2)">
											<div class="wizard-wrapper">
												<div class="wizard-icon">
													<i class="wizard-check ki ki-check"></i>
													<span class="wizard-number">2</span>
												</div>
												<div class="wizard-label">
													<h3 class="wizard-title">Centre/School Details</h3>
													<div class="wizard-desc">Setup details</div>
												</div>
											</div>
										</div>
										<div class="wizard-step" data-wizard-type="step" :data-wizard-state="getState(3)">
											<div class="wizard-wrapper">
												<div class="wizard-icon">
													<i class="wizard-check ki ki-check"></i>
													<span class="wizard-number">3</span>
												</div>
												<div class="wizard-label">
													<h3 class="wizard-title">Review and Submit</h3>
													<div class="wizard-desc">Review your school details and submit</div>
												</div>
											</div>
										</div>

										<div class="wizard-step" data-wizard-type="step" :data-wizard-state="getState(4)">
											<div class="wizard-wrapper">
												<div class="wizard-icon">
													<i class="wizard-check ki ki-check"></i>
													<span class="wizard-number">4</span>
												</div>
												<div class="wizard-label">
													<h3 class="wizard-title">Completed</h3>
													<div class="wizard-desc">Your application is successfull</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="d-flex flex-row-auto bgi-no-repeat bgi-position-y-bottom bgi-position-x-center bgi-size-contain pt-2 pt-lg-5" 
									v-bind:style="{'height': 'calc(100% - 430px)', 'background-size': 'cover', 'background-image': 'url(' + sidebar_image[step-1] + ')' }">
									</div>
						</div>
						<div class="wizard-content bg-gray-100 d-flex flex-column flex-row-fluid py-5 pt-15 px-5 px-lg-10">
							<div class="text-right mb-15 mr-xxl-10">
								<a href="https://kinnections.com.au/"><img src="https://kinnections.com.au/wp-content/uploads/2022/02/logo.png"></a>
							</div>
							<div class="d-flex justify-content-center flex-row-fluid">
								<form ref="formData" @submit.prevent="handleSubmit(!v$.$invalid)"  class="pb-5 w-100 px-lg-10 fv-plugins-bootstrap fv-plugins-framework">
									<div class="pb-5" v-show="step == 1">
										<div class="pb-10 pb-5">
											<h3 class="font-weight-bolder text-dark font-size-h2">Kinnections Agreement</h3>
											<div class="text-muted font-weight-bold font-size-h6">Agree to Terms and Conditions</div>
										</div>
										<p class="fs-14 pb-5" style="font-size: 1.08rem">Thank you for your interest in Kinnections. To progress to the Subscription Form, please confirm that you have read and accept the Kinnections Licence and Terms of Use Agreement by selecting a response below;</p>
										<div style="height: 300px;overflow: auto" class="mt-5">
											<h4>Kinnections Licence And Terms Of Use Agreement</h4>

											<div class="et_pb_module et_pb_text et_pb_text_1 content-li  et_pb_text_align_left et_pb_bg_layout_light"><div class="et_pb_text_inner">Permission to use this digital hosted service (Service) is conditional upon the school names in the Schedule (“you”) agreeing to the terms and conditions set out below. The Service is offered to you by Joshua Vaughan, trading as KINNECTIONS AUSTRALIA Pty Ltd, ABN 56631141412 (Licensor).<p></p><p>By executing this licence agreement, you agree to comply with this terms and conditions, which will bind you and your teachers and any other personnel involved in the Services.</p><ol style="margin-top: 30px;"><li><span><strong>Warning</strong></span><ol><li>Before you agree to the terms of this licence agreement, you must read the terms and conditions of this licence (<strong>Licence Agreement</strong>).</li><li>If you do not agree with the terms and conditions of this Licence Agreement, you must not access, download or install the software application available as part of the Services, or otherwise attempt to benefit from the Services.</li></ol></li><li><span><strong>Acknowledgment</strong></span><ol><li>By accessing, downloading, installing or using the Service, you will be deemed to:<ol><li>have read this Licence Agreement;</li><li>fully understand the terms of this Licence Agreement;</li><li>agree to be bound by the terms of this Licence Agreement; and</li><li>understand that this Licence Agreement is a legal agreement between you and the Licensor and can be enforced accordingly.</li></ol></li></ol></li><li><span><strong>Scope of Licence for Full Version</strong></span><ol><li>If you have made payment to the Licensor for:<ol><li><strong>a Single-Classroom Service Licence</strong><span>&nbsp;</span>then you may use the Service on only one computer or device that you own or operate in one classroom and/or one device owned by the designated classroom teacher. You may transfer the Service from one such computer to another that you own or operate provided that you do not use or permit the usage of the Service in more than one classroom at a time.</li><li><strong>a Multi-Classroom Service Licence</strong><span>&nbsp;</span>then you may use the Service on only one computer network that you own or operate within your school and only then in respect of data files created by teachers in your school. This extends to the one device owned by the designated classroom teachers. You may transfer the Service from one computer to another that you own or operate on your school network provided that you do not use or permit the use of the Service by any person from another school, nor permit the use of the Service in respect of data files not created by you or by a teacher at another school.</li></ol></li><li>The grant of any licence under this clause 3 is conditional upon you paying the licence fee. The licence fee will be charged at times and in amounts as agreed between you and Licensor (failing which no licence is granted). If any licence fees are not agreed or not paid, this Licence Agreement (together with any licence granted to you under it) is terminated in accordance with clause 12 without further risk or liability to Licensor.</li></ol></li><li><span><strong>Scope of Licence for Trial Version</strong></span><ol><li>If you are accessing, using or downloading any trial version of the Service:<ol><li>you are only licensed to use the trial version of the Service for the trial period of 30 days (or for such period as is otherwise specified by Licensor) (<strong>Trial Period</strong>);</li><li>you acknowledge and agree that the Licensor may directly end trial use at any time in accordance with clause 2(b);</li><li>you must not use the Service beyond the Trial Period unless you pay the licence fee;</li><li>you understand that the Services may cease to function either in whole or in part beyond the Trial Period if you do not purchase a valid licence from the Licensor; and</li><li>you must remove any data, which may remain from use of the Service, from your computer if you do not purchase a valid licence from the Licensor after the Trial Period ends.</li><li>You agree that the Licensor may retain information such as your login details and usage data after the expiry of the Trial Period only for the purpose of allowing you to create or reactivate an account for the Service.</li></ol></li></ol></li><li><span><strong>Licence Fee</strong></span><ol><li>The licence fee payable by you for use of the Service is as described in the Schedule.</li><li>By paying the licence fee you will be granted access to the Service as described in the Schedule (<strong>Agreement Period).</strong></li><li>Following expiry of the Initial Subscription Period if applicable and as described in the Schedule, you will be charged in accordance with your selected package as described in the Schedule and granted access to the Service. (<strong>Agreement Period</strong>).</li><li>The Renewal Period is renewed on the same terms as clause 5.3.</li><li>Except in the event of early termination of this Licence Agreement in accordance with clause 12, you shall pay the licence fee for the Initial Subscription Period and any Renewal Period.</li><li>Should the Licensor wish to modify the licence fee for any Renewal Period, Licensor will endeavor to issue you with a renewal notification specifying the proposed licence fee for the Service not less than 3 weeks prior to the end of the Initial Subscription Period (or Renewal Period, if applicable).</li></ol></li><li><span><strong>Ownership and Intellectual Property Rights</strong></span><ol><li>You agree and acknowledge that:<ol><li>all Intellectual Property Rights in the Service including, without limitation, patents, copyright and trade marks are owned or licensed by and remain at all times with the Licensor;</li><li>nothing in this Licence Agreement operates to give you any ownership rights in the Service; and</li><li>use of the Service by you, or any other person or entity, not in accordance with this Licence Agreement is a breach of this Licence Agreement.</li></ol></li><li>Nothing in this Licence Agreement affects the ownership of moral rights in the Service.</li></ol></li><li><span><strong>Collection of Personal Data</strong></span><ol><li>You agree that the Licensor may collect and use personal information and data of students, teachers and other persons from your school in accordance with our privacy policy. Further details on how we may treat this data can be found in our Privacy Policy.</li><li>You warrant that before utilising the Services, that you have obtained necessary consents from any person utilising the Services (including teachers and students, including the parent or guardian of students). Such consents include consent for Kinnections to:<ol><li>Record conversations between the relevant student(s) and teacher(s).</li><li>Process information recorded in conversations between students and teachers.</li><li>Provide reports and other information to teachers and to you which relate to student welfare and related matters.</li><li>Store recorded materials, personal information and data on secure servers which are hosted by professional IT support service providers (where the servers may be cloud based and hosted in multiple jurisdictions).</li></ol></li></ol></li><li><span><strong>Restrictions on use</strong></span><ol><li>To the maximum extent permitted by law, you must not copy, alter, modify, adapt, translate, rent, lease, lend or commercially exploit or create derivative works of the Service, the application software, website or any part of the Service.</li><li>You must not reverse engineer, decompile or disassemble the Service, or any part of that Service, other than as permitted by applicable law.</li><li>You must not create or attempt to create the source code from the object code of the Service.</li><li>The Service is licensed as a whole and, subject to clause 3, its component parts may not be separated for use on more than one computer or computer network.</li><li>You must use the Service strictly in accordance with the procedures set out in any accordance with any user help file, guide or website incorporated with the Service and otherwise in accordance with any user directions that may be issued by or on behalf of the Licensor from time to time.</li><li>The Licensor is not required to provide updates or new releases of the Service pursuant to this Licence Agreement and you acknowledge that the provision of upgrades or new releases may be the subject of a separate agreement.</li><li>You agree that you must protect the Service at all times from unauthorised access, use or damage.</li></ol></li><li><span><strong>Risk</strong></span><ol><li>You will use the Service at your sole and entire risk (including that of your students, teachers or other persons utilising the Services).</li><li>You acknowledge and agree that the Service does not necessarily provide definitive answers and solutions and that the effective and accurate use of the Service necessarily requires an element of human intervention and careful selection.</li></ol></li><li><span><strong>Liability</strong></span><ol><li>Australian laws may give you certain rights or limit the operation of certain provisions of this Licence Agreement. The limitation set out in this clause is subject to those laws.</li><li>All express or implied warranties, representations, statements, terms and conditions relating to this Licence Agreement, not contained in this Licence Agreement, are, subject to clause 3, excluded from this Licence Agreement to the extent permitted by law.</li><li>Nothing in this Licence Agreement excludes, restricts or modifies any condition, warranty, right or remedy implied or imposed by any statute or regulation, including without limitation the<span>&nbsp;</span><em>Consumer and Competition Act 2010 (Cth.),</em><span>&nbsp;</span>which cannot lawfully be excluded, restricted or modified, including without limitation implied terms and warranties which operate to protect the purchasers of goods and services in various circumstances.</li><li>If any condition or warranty is implied into this Licence Agreement under the<span>&nbsp;</span><em>Consumer and Competition Act 2010 (Cth.)</em><span>&nbsp;</span>(or other applicable statutes or regulations) and cannot be excluded, and the Licensor is able to limit your remedy for a breach of such a condition or warranty, then the Licensor’s liability for breach of the condition or warranty is limited to one or more of the following at the Licensor’s option:<ol><li>in the case of goods, replacement of the goods<span>&nbsp;</span><strong>o</strong>r the supply of equivalent goods; repair of the goods; the payment of the cost of replacing the goods or of acquiring equivalent goods; or the payment of the cost of having the goods repaired; or</li><li>in the case of services, supplying of the services again; or payment of the cost of having the services supplied again.</li></ol></li><li>Subject to the Licensor’s obligations under the implied conditions and warranties referred to in clause 3, the Licensor’s maximum aggregate liability for all claims under or relating to this Licence Agreement or its subject matter (including, without limitation and if applicable, any claims from students or teachers at your school who use the Services), whether in contract, tort (including without limitation negligence), in equity, under statute, under an indemnity or on any other basis, is limited to an amount equal to the fees, if any, paid by you under this Licence Agreement.</li><li>Subject to the Licensor’s obligations under the implied conditions and warranties referred to in clause 3, the Licensor is not liable for, and no measure of damages will, under any circumstances, include:<ol><li>special, indirect, consequential, incidental or punitive damages; or</li><li>economic loss, loss of profits, revenue, goodwill, bargain, anticipated savings or loss or corruption of data, whether in an action in contract, tort (including without limitation negligence), product liability, statute, under an indemnity or on any other basis, whether or not such loss or damage was foreseeable and even if advised of the possibility of the loss or damage.</li></ol></li></ol></li><li><span><strong>Indemnity</strong></span><ol><li>You hereby indemnify the Licensor against any liabilities, losses, expenses or other costs (including, but not limited to, reasonable legal fees) arising from or in relation to any wilful, negligent or unlawful act or omission of, or breach of this Licence Agreement by you, or (to the extent permitted by law) any use of or reliance by you on the Service.</li><li>Where this clause refers to a person who is not a party to this Licence Agreement then the Licensor holds the benefit of this clause on trust for them.</li></ol></li><li><span><strong>Term and termination</strong></span><ol><li>This Licence Agreement remains in effect unless it is terminated under this clause 12.</li><li>Licensor may terminate this Licence Agreement with immediate effect by giving written notice if:<ol><li>you breach one or more obligations under this Licence Agreement and, within 14 days of receiving a written notice from Licensor, fails to rectify the breach;</li><li>you commit a material breach which, in Licensor’s opinion, is not capable of being rectified;</li><li>one of your warranties is, or becomes, untrue;</li><li>you become, threaten or resolve to become or is in jeopardy of becoming subject to any form of insolvency administration.</li></ol></li><li><strong>Trial Version.<span>&nbsp;</span></strong>If you are accessing or using the trial version of the Service:<ol><li>you may terminate this Licence Agreement at any time by permanently removing the Service from each computer and/or network you operate;</li><li>Licensor may terminate this Licence Agreement immediately for any reason by giving you written notice;</li><li>upon notification of termination of the Licence Agreement by the Licensor, you must destroy all of your copies of the Service; and</li><li>all provisions in this Licence Agreement relating to confidentiality, intellectual property rights and non-disclosure survive the termination of this Licence Agreement.</li></ol></li><li><strong>Full Version</strong>. If you are accessing or using the full (registered) version of the Service:<ol><li>you may terminate this Licence Agreement at any time by permanently removing all of your copies of the Service from each computer and/or network you operate;</li><li>Licensor may terminate this Licence Agreement if you breach any term or condition of this Licence Agreement and, upon such termination, you must destroy any data which may remain on your computer in connection with the Serviceand cease accessing the Service.</li><li>on termination of this Licence Agreement, you will not be entitled to a refund of any fees or charges paid by you for the Service; and</li><li>all provisions in this Licence Agreement relating to confidentiality, intellectual property rights and non-disclosure survive the termination of this Licence Agreement.</li></ol></li><li>Termination of this Licence Agreement will be in addition to and not in lieu of any other remedies available to the Licensor.</li></ol></li><li><strong>&nbsp;<span>Upgrade and product exchange</span></strong><ol><li>In the event of an upgrade or product exchange, the licence granted under this Licence Agreement will automatically transfer to the new version or product. All of your rights in respect of the original product will lapse and you will not be permitted to make further use of it.</li></ol></li><li><span><strong>Entire agreement</strong></span><ol><li>This Licence Agreement is the entire agreement between the parties about its subject matter and replaces all previous agreements, understandings, representations and warranties about that subject matter.</li><li>Each party represents and warrants that it has not relied on any representations or warranties about the subject matter of this Licence Agreement except as expressly provided in this Licence Agreement.</li></ol></li><li><span><strong>Variation</strong></span><ol><li>The Licensor may vary this Licence Agreement at any time in writing by notifying you in advance of any variation by contacting you directly by any means, including by pop-up screens on the service, email or any other electronic communication including placing the varied terms and conditions on the Licensor’s website. If you do not accept a duly notified variation to this Licence Agreement, this Licence Agreement (together with any licence granted to you under it) is terminated without further risk or liability to Licensor.</li></ol></li><li><span><strong>Law</strong></span><ol><li>This Licence Agreement will be governed by and construed in accordance with the laws for the time being in force in the Australian Capital Territory and the parties agree to submit to the jurisdiction of the courts and tribunals of the Australian Capital Territory.</li></ol></li><li><span><strong>Waiver</strong></span><ol><li>No forbearance, delay or indulgence by a party in enforcing the provisions of this Licence Agreement will prejudice or restrict the rights of that party, nor will any waiver of those rights operate as a waiver of any subsequent breach.</li></ol></li><li>&nbsp;<span><strong>Assignment, novation and other dealings</strong></span><ol><li>You must not assign or novate this Licence Agreement or otherwise deal with the benefit of it or a right under it, or purport to do so, without the Licensor’s prior written consent, which may be withheld at the Licensor’s absolute discretion.</li></ol></li><li><span><strong>Capacity and third party rights</strong></span><ol><li>You warrant to the Licensor that you have legal capacity to enter into and be bound by this Licence Agreement.</li><li>Save as expressly provided otherwise in this Licence Agreement:<ol><li>each person who executes this Licence Agreement does so solely in his, her or its own legal capacity and not as agent or trustee for or a partner of any other entity; and</li><li>only those persons who execute this Licence Agreement have a right or benefit under it.</li></ol></li></ol></li><li><span><strong>Severability</strong></span><ol><li>Should any part of this Licence Agreement be or become invalid, that part will be severed from this Licence Agreement. Such invalidity will not affect the validity of the remaining provisions of this Licence Agreement.</li></ol></li></ol></div></div>
										</div>
										<p class="fs-14 mt-4">
											<label class="form-check form-check-sm form-check-custom form-check-solid me-5">
												<input type="checkbox" :class="{'p-invalid': !agree && isAgreementNext }" v-model="agree" class="form-check-input">
												<span :class="{'p-error': !agree && isAgreementNext }">I have read and agree with the Kinnections Licence and Terms of Use Agreement</span>
											</label>
										 </p>
									</div>
									<div class="pb-5" v-show="step == 2">
										<div class="pb-10 pb-lg-15">
											<h3 class="font-weight-bold text-dark font-size-h2 text-center">Centre/School Details</h3>
											<div class="text-muted font-weight-bold font-size-h6 text-center d-none">Setup Your School  and Subscription Details</div>
										</div>
										<div class="row">
											<div class="col-12">
											<div class="font-weight-bold font-size-h6 pb-4">How to complete this form: </div>
												<p class="mb-0">1. Add all required Centre/School information. </p>
												<p class="mb-0">2. Add all required contact details. </p>
												<p class="pb-5">3. Review the details and click the submit button to finalise the onboarding. </p>
											</div>
											<div class="col-12 col-lg-6 col-md-6">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Date</label>
													<input type="date" v-model="state.subscription_date" id="kt_daterangepicker_3" class="form-control h-auto p-3 border-0 rounded-md font-size-h5" placeholder="DD-MM-YYYYY" name="subscription_date" >
												<div class="fv-plugins-message-container"></div></div>
											</div>
											<div class="col-12 col-lg-6 col-md-6">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Annual Subscription</label>
														<select name="annual_subscription"  v-model="state.annual_subscription" class="form-control h-auto p-3 border-0 rounded-md font-size-h6">
															<option value="">Select</option>
															<option value="Yes">Yes</option>
															<option value="No">No</option>
														</select>
													<div class="fv-plugins-message-container"></div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-12 col-md-12">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Name of Centre/School</label>
													<input type="text" v-model="v$.name.$model" :class="{'p-invalid': isValid(v$.name) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="name" >
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.name)" class="p-error">{{ getError(v$.name, 'School Name')}}</span>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-12 col-lg-6 col-md-6">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Centre/School website</label>
													<input type="text" v-model="v$.website.$model" :class="{'p-invalid': isValid(v$.website) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="website">
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.website)" class="p-error">{{ getError(v$.website, 'Website')}}</span>
													</div>
												</div>
											</div>

											<div class="col-12 col-lg-6 col-md-6">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Centre/School email address</label>
													<input type="text" v-model="v$.school_email.$model" :class="{'p-invalid': isValid(v$.school_email) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="school_email">
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.school_email)" class="p-error">{{ getError(v$.school_email, 'School Email Address')}}</span>
													</div>
												</div>
											</div>

											<div class="col-lg-12 col-md-12">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Street address</label>
													<input type="text" v-model="v$.street_address.$model" :class="{'p-invalid': isValid(v$.street_address) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="street_address">
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.street_address)" class="p-error">{{ getError(v$.street_address, 'Street Address')}}</span>
													</div>
												</div>
											</div>

											<div class="col-12 col-lg-6 col-md-6">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Suburb</label>
													<input type="text" v-model="v$.suburb.$model" :class="{'p-invalid': isValid(v$.suburb) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="suburb" >
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.suburb)" class="p-error">{{ getError(v$.suburb, 'Suburb')}}</span>
													</div>
												</div>
											</div>

												<div class="col-12 col-lg-6 col-md-6">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bolder text-dark">City</label>
													<input type="text" v-model="v$.city.$model" :class="{'p-invalid': isValid(v$.city) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="city" >
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.city)" class="p-error">{{ getError(v$.city, 'City')}}</span>
													</div>
												</div>
											</div>

											<div class="col-12 col-lg-6 col-md-6">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">State</label>
													<input type="text" v-model="v$.state.$model" :class="{'p-invalid': isValid(v$.state) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="state">
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.state)" class="p-error">{{ getError(v$.state, 'State')}}</span>
													</div>
												</div>
											</div>

											<div class="col-12 col-lg-6 col-md-6">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Postcode</label>
													<input type="text" v-model="v$.zip.$model" :class="{'p-invalid': isValid(v$.zip) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="zip">
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.zip)" class="p-error">{{ getError(v$.zip, 'Post Code')}}</span>
													</div>
												</div>
											</div>

											<div class="col-12 col-lg-12 col-md-12">
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bolder text-dark">Country</label>
													<select name="country"  v-model="v$.country.$model" :class="{'p-invalid': isValid(v$.country) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6">
															<option value="">Select</option>
															<option v-for="(c, i) in countryList" :value="c.name" :key="i">{{c.name}}</option>
													</select>
													<div class="fv-plugins-message-container">
														 <span v-if="isValid(v$.country)" class="p-error">{{ getError(v$.country, 'Country')}}</span>
													</div>
												</div>
											</div>

											<div class="pb-5 pt-4 px-4" >
												<div class="pb-10 pb-lg-15">
													<h3 class="font-weight-bold text-dark font-size-h2 text-center">Contact Information</h3>
													<div class="text-muted font-weight-bold font-size-h6 text-center d-none">Setup Your Contact Information</div>
												</div>
												<div class="form-group fv-plugins-icon-container">
													<label class="font-size-h6 font-weight-bold text-dark">Contact name</label>
													<input type="text" v-model="v$.contact_name.$model" :class="{'p-invalid': isValid(v$.contact_name) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="contact_name">
													<div class="fv-plugins-message-container">
														<span v-if="isValid(v$.contact_name)" class="p-error">{{ getError(v$.contact_name, 'Contact Name')}}</span>
													</div>
												</div>
												<div class="row">
													<div class="col-lg-12 col-md-12">
														<div class="form-group fv-plugins-icon-container">
															<label class="font-size-h6 font-weight-bold text-dark">Position</label>
															<input type="text" v-model="v$.position.$model" :class="{'p-invalid': isValid(v$.position) }"  class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="position">
															<div class="fv-plugins-message-container">
																<span v-if="isValid(v$.position)" class="p-error">{{ getError(v$.position, 'Position')}}</span>
															</div>
														</div>
													</div>

													<div class="col-lg-6 col-md-6">
														<div class="form-group fv-plugins-icon-container">
															<label class="font-size-h6 font-weight-bold text-dark">Work phone number</label>
															<input type="text"  v-model="v$.work_phone.$model" :class="{'p-invalid': isValid(v$.work_phone) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="work_phone">
															<div class="fv-plugins-message-container">
																<span v-if="isValid(v$.work_phone)" class="p-error">{{ getError(v$.work_phone, 'Work Phone Number')}}</span>
															</div>
														</div>
													</div>

													<div class="col-lg-6 col-md-6">
														<div class="form-group fv-plugins-icon-container">
															<label class="font-size-h6 font-weight-bold text-dark">Mobile phone number</label>
															<input type="text" v-model="v$.mobile_phone.$model" :class="{'p-invalid': isValid(v$.mobile_phone) }" class="form-control h-auto p-3 border-0 rounded-md font-size-h6" name="mobile_phone" >
															<div class="fv-plugins-message-container">
																<span v-if="isValid(v$.mobile_phone)" class="p-error">{{ getError(v$.mobile_phone, 'Mobile Phone Number')}}</span>
															</div>
														</div>
													</div>

													<div class="col-lg-12 col-md-12">
														<div class="form-group fv-plugins-icon-container">
															<label class="font-size-h6 font-weight-bold text-dark">Email</label>
															<input type="email" v-model="v$.email.$model" :class="{'p-invalid': isValid(v$.email) }"  class="form-control h-auto p-4 border-0 rounded-lg font-size-h6" name="email" >
															<div class="fv-plugins-message-container">
																<span v-if="isValid(v$.email)" class="p-error">{{ getError(v$.email, 'Email')}}</span>
															</div>
														</div>
													</div>
												</div>
											</div>

										</div>
									</div>

									<div class="pb-5" v-show="step == 3">
										<div class="pb-10 pb-lg-15">
											<h3 class="font-weight-bolder text-dark font-size-h2">Review Details</h3>
											<div class="text-muted font-weight-bold font-size-h6">Review your school details before submitting</div>
										</div>
										<div class="text-dark-50 line-height-lg mb-8 d-flex">
											<div style="width: 50%"><b> Date </b><br> {{ state.subscription_date }}</div>
											<div><b>Annual Subscription </b> <br> {{ state.annual_subscription }}</div>
										</div>

										<h4 class="font-weight-bolder mb-3">School Information</h4>
										<div class="text-dark-50 pt-4 line-height-lg mb-8">
											<div class="mb-5"><b>Name of Centre/School</b> <br> {{ state.name }}</div> 
											<div class="mb-5"><b>Centre/School website </b> <br>  {{ state.website }}</div>
											<div class="mb-4"><b>Centre/School email address </b> <br> {{ state.school_email }}</div>

											<div class="mb-5"><b>Street address </b> <br>  {{ state.street_address }}</div>
											<div class="mb-5"><b>Suburb </b><br>  {{ state.suburb }}</div>
											<div class="mb-5"><b>City </b> <br> {{ state.city }}</div>
											<div class="d-flex">
											<div class="mb-5" style="width: 50%"><b>State </b> {{ state.state }}</div>
											<div class="mb-5"><b>Post Code </b> {{ state.zip }}</div>
											</div>
											<div class="mb-5"><b>Country </b> <br> {{ state.country }}</div>
											
										</div>
										<h4 class="font-weight-bolder mb-3">Contact Information</h4>
										<div class="text-dark-50 pt-4 line-height-lg mb-8">
											<div class="mb-5"><b>Contact name </b> <br>{{ state.contact_name }}</div>
											<div class="mb-5"><b>Position</b> <br>{{ state.position }}</div>
											<div class="mb-5"><b>Work phone number </b> <br>{{ state.work_phone }}</div>
											<div class="mb-5"><b>Mobile phone number</b> <br>{{ state.mobile_phone }}</div>
											<div class="mb-5"><b>Email </b> <br>{{ state.email }}</div>
										</div>
									</div>
									<div class="d-flex justify-content-between pt-3">
										<div class="mr-2">
											<button type="button" class="btn btn-light-primary font-weight-bolder font-size-h6 pl-6 pr-8 py-4 my-3 mr-3"  v-if="step > 1 && step < 4" @click="step--">
											<span class="svg-icon svg-icon-md mr-1">
												<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
													<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<polygon points="0 0 24 0 24 24 0 24"></polygon>
														<rect fill="#000000" opacity="0.3" transform="translate(15.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -12.000000)" x="14" y="7" width="2" height="10" rx="1"></rect>
														<path d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z" fill="#000000" fill-rule="nonzero" transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997)"></path>
													</g>
												</svg>
											</span>Previous</button>
										</div>
										<div>
											<button type="submit" class="btn btn-primary font-weight-bolder font-size-h6 pl-8 pr-4 py-4 my-3" v-if="step < 4">
												<span v-if="step ==  2">Next Step </span>
												<span v-else-if="step ==  3">Submit </span>
												<span v-else>Agree </span>
												<span class="svg-icon svg-icon-md ml-1">
													<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
														<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
															<polygon points="0 0 24 0 24 24 0 24"></polygon>
															<rect fill="#000000" opacity="0.3" transform="translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000)" x="7.5" y="7.5" width="2" height="9" rx="1"></rect>
															<path d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z" fill="#000000" fill-rule="nonzero" transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)"></path>
														</g>
													</svg>
												</span>
										  </button>
										</div>
									</div>
									<div class="text-center py-20 my-10" v-if="step == 4">
										<h2 class="fs-2x fw-bold mb-10">Thank you</h2>
										<p class="text-gray-400 fs-5 fw-semobold mb-5"><span>We have received your onboarding form<br>We will contact you as soon as possible.</span></p>
										<a href="https://kinnections.com.au/" class="btn btn-primary btn-md px-4" style="width: 150px">Home</a>
									</div>
								<div></div><div></div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div><br><br>
        </div>
        </div>
    </div>    
</template>
<script>
import { defineComponent, ref, watch, onMounted, provide, reactive, inject } from 'vue'
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import  SchoolsOnboarding  from '@/composables/schools/SchoolsOnboarding'
import { ElLoading } from 'element-plus'

export default defineComponent({
    setup() {
        const { utils, store, toast, http, constants } = inject('App') 
        const { loading, response, submitOnboarding } = SchoolsOnboarding(http, constants)

        const step = ref(1)
        const classList = ref(1)
		const formData = ref('')
		const submitted = ref(false)
		const agree = ref(false)
		const isAgreementNext = ref(false)
		const countryList = ref([ 
			{name: 'Afghanistan', code: 'AF'}, 
			{name: 'Åland Islands', code: 'AX'}, 
			{name: 'Albania', code: 'AL'}, 
			{name: 'Algeria', code: 'DZ'}, 
			{name: 'American Samoa', code: 'AS'}, 
			{name: 'AndorrA', code: 'AD'}, 
			{name: 'Angola', code: 'AO'}, 
			{name: 'Anguilla', code: 'AI'}, 
			{name: 'Antarctica', code: 'AQ'}, 
			{name: 'Antigua and Barbuda', code: 'AG'}, 
			{name: 'Argentina', code: 'AR'}, 
			{name: 'Armenia', code: 'AM'}, 
			{name: 'Aruba', code: 'AW'}, 
			{name: 'Australia', code: 'AU'}, 
			{name: 'Austria', code: 'AT'}, 
			{name: 'Azerbaijan', code: 'AZ'}, 
			{name: 'Bahamas', code: 'BS'}, 
			{name: 'Bahrain', code: 'BH'}, 
			{name: 'Bangladesh', code: 'BD'}, 
			{name: 'Barbados', code: 'BB'}, 
			{name: 'Belarus', code: 'BY'}, 
			{name: 'Belgium', code: 'BE'}, 
			{name: 'Belize', code: 'BZ'}, 
			{name: 'Benin', code: 'BJ'}, 
			{name: 'Bermuda', code: 'BM'}, 
			{name: 'Bhutan', code: 'BT'}, 
			{name: 'Bolivia', code: 'BO'}, 
			{name: 'Bosnia and Herzegovina', code: 'BA'}, 
			{name: 'Botswana', code: 'BW'}, 
			{name: 'Bouvet Island', code: 'BV'}, 
			{name: 'Brazil', code: 'BR'}, 
			{name: 'British Indian Ocean Territory', code: 'IO'}, 
			{name: 'Brunei Darussalam', code: 'BN'}, 
			{name: 'Bulgaria', code: 'BG'}, 
			{name: 'Burkina Faso', code: 'BF'}, 
			{name: 'Burundi', code: 'BI'}, 
			{name: 'Cambodia', code: 'KH'}, 
			{name: 'Cameroon', code: 'CM'}, 
			{name: 'Canada', code: 'CA'}, 
			{name: 'Cape Verde', code: 'CV'}, 
			{name: 'Cayman Islands', code: 'KY'}, 
			{name: 'Central African Republic', code: 'CF'}, 
			{name: 'Chad', code: 'TD'}, 
			{name: 'Chile', code: 'CL'}, 
			{name: 'China', code: 'CN'}, 
			{name: 'Christmas Island', code: 'CX'}, 
			{name: 'Cocos (Keeling) Islands', code: 'CC'}, 
			{name: 'Colombia', code: 'CO'}, 
			{name: 'Comoros', code: 'KM'}, 
			{name: 'Congo', code: 'CG'}, 
			{name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
			{name: 'Cook Islands', code: 'CK'}, 
			{name: 'Costa Rica', code: 'CR'}, 
			{name: 'Cote D\'Ivoire', code: 'CI'}, 
			{name: 'Croatia', code: 'HR'}, 
			{name: 'Cuba', code: 'CU'}, 
			{name: 'Cyprus', code: 'CY'}, 
			{name: 'Czech Republic', code: 'CZ'}, 
			{name: 'Denmark', code: 'DK'}, 
			{name: 'Djibouti', code: 'DJ'}, 
			{name: 'Dominica', code: 'DM'}, 
			{name: 'Dominican Republic', code: 'DO'}, 
			{name: 'Ecuador', code: 'EC'}, 
			{name: 'Egypt', code: 'EG'}, 
			{name: 'El Salvador', code: 'SV'}, 
			{name: 'Equatorial Guinea', code: 'GQ'}, 
			{name: 'Eritrea', code: 'ER'}, 
			{name: 'Estonia', code: 'EE'}, 
			{name: 'Ethiopia', code: 'ET'}, 
			{name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
			{name: 'Faroe Islands', code: 'FO'}, 
			{name: 'Fiji', code: 'FJ'}, 
			{name: 'Finland', code: 'FI'}, 
			{name: 'France', code: 'FR'}, 
			{name: 'French Guiana', code: 'GF'}, 
			{name: 'French Polynesia', code: 'PF'}, 
			{name: 'French Southern Territories', code: 'TF'}, 
			{name: 'Gabon', code: 'GA'}, 
			{name: 'Gambia', code: 'GM'}, 
			{name: 'Georgia', code: 'GE'}, 
			{name: 'Germany', code: 'DE'}, 
			{name: 'Ghana', code: 'GH'}, 
			{name: 'Gibraltar', code: 'GI'}, 
			{name: 'Greece', code: 'GR'}, 
			{name: 'Greenland', code: 'GL'}, 
			{name: 'Grenada', code: 'GD'}, 
			{name: 'Guadeloupe', code: 'GP'}, 
			{name: 'Guam', code: 'GU'}, 
			{name: 'Guatemala', code: 'GT'}, 
			{name: 'Guernsey', code: 'GG'}, 
			{name: 'Guinea', code: 'GN'}, 
			{name: 'Guinea-Bissau', code: 'GW'}, 
			{name: 'Guyana', code: 'GY'}, 
			{name: 'Haiti', code: 'HT'}, 
			{name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
			{name: 'Holy See (Vatican City State)', code: 'VA'}, 
			{name: 'Honduras', code: 'HN'}, 
			{name: 'Hong Kong', code: 'HK'}, 
			{name: 'Hungary', code: 'HU'}, 
			{name: 'Iceland', code: 'IS'}, 
			{name: 'India', code: 'IN'}, 
			{name: 'Indonesia', code: 'ID'}, 
			{name: 'Iran, Islamic Republic Of', code: 'IR'}, 
			{name: 'Iraq', code: 'IQ'}, 
			{name: 'Ireland', code: 'IE'}, 
			{name: 'Isle of Man', code: 'IM'}, 
			{name: 'Israel', code: 'IL'}, 
			{name: 'Italy', code: 'IT'}, 
			{name: 'Jamaica', code: 'JM'}, 
			{name: 'Japan', code: 'JP'}, 
			{name: 'Jersey', code: 'JE'}, 
			{name: 'Jordan', code: 'JO'}, 
			{name: 'Kazakhstan', code: 'KZ'}, 
			{name: 'Kenya', code: 'KE'}, 
			{name: 'Kiribati', code: 'KI'}, 
			{name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
			{name: 'Korea, Republic of', code: 'KR'}, 
			{name: 'Kuwait', code: 'KW'}, 
			{name: 'Kyrgyzstan', code: 'KG'}, 
			{name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
			{name: 'Latvia', code: 'LV'}, 
			{name: 'Lebanon', code: 'LB'}, 
			{name: 'Lesotho', code: 'LS'}, 
			{name: 'Liberia', code: 'LR'}, 
			{name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
			{name: 'Liechtenstein', code: 'LI'}, 
			{name: 'Lithuania', code: 'LT'}, 
			{name: 'Luxembourg', code: 'LU'}, 
			{name: 'Macao', code: 'MO'}, 
			{name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
			{name: 'Madagascar', code: 'MG'}, 
			{name: 'Malawi', code: 'MW'}, 
			{name: 'Malaysia', code: 'MY'}, 
			{name: 'Maldives', code: 'MV'}, 
			{name: 'Mali', code: 'ML'}, 
			{name: 'Malta', code: 'MT'}, 
			{name: 'Marshall Islands', code: 'MH'}, 
			{name: 'Martinique', code: 'MQ'}, 
			{name: 'Mauritania', code: 'MR'}, 
			{name: 'Mauritius', code: 'MU'}, 
			{name: 'Mayotte', code: 'YT'}, 
			{name: 'Mexico', code: 'MX'}, 
			{name: 'Micronesia, Federated States of', code: 'FM'}, 
			{name: 'Moldova, Republic of', code: 'MD'}, 
			{name: 'Monaco', code: 'MC'}, 
			{name: 'Mongolia', code: 'MN'}, 
			{name: 'Montserrat', code: 'MS'}, 
			{name: 'Morocco', code: 'MA'}, 
			{name: 'Mozambique', code: 'MZ'}, 
			{name: 'Myanmar', code: 'MM'}, 
			{name: 'Namibia', code: 'NA'}, 
			{name: 'Nauru', code: 'NR'}, 
			{name: 'Nepal', code: 'NP'}, 
			{name: 'Netherlands', code: 'NL'}, 
			{name: 'Netherlands Antilles', code: 'AN'}, 
			{name: 'New Caledonia', code: 'NC'}, 
			{name: 'New Zealand', code: 'NZ'}, 
			{name: 'Nicaragua', code: 'NI'}, 
			{name: 'Niger', code: 'NE'}, 
			{name: 'Nigeria', code: 'NG'}, 
			{name: 'Niue', code: 'NU'}, 
			{name: 'Norfolk Island', code: 'NF'}, 
			{name: 'Northern Mariana Islands', code: 'MP'}, 
			{name: 'Norway', code: 'NO'}, 
			{name: 'Oman', code: 'OM'}, 
			{name: 'Pakistan', code: 'PK'}, 
			{name: 'Palau', code: 'PW'}, 
			{name: 'Palestinian Territory, Occupied', code: 'PS'}, 
			{name: 'Panama', code: 'PA'}, 
			{name: 'Papua New Guinea', code: 'PG'}, 
			{name: 'Paraguay', code: 'PY'}, 
			{name: 'Peru', code: 'PE'}, 
			{name: 'Philippines', code: 'PH'}, 
			{name: 'Pitcairn', code: 'PN'}, 
			{name: 'Poland', code: 'PL'}, 
			{name: 'Portugal', code: 'PT'}, 
			{name: 'Puerto Rico', code: 'PR'}, 
			{name: 'Qatar', code: 'QA'}, 
			{name: 'Reunion', code: 'RE'}, 
			{name: 'Romania', code: 'RO'}, 
			{name: 'Russian Federation', code: 'RU'}, 
			{name: 'RWANDA', code: 'RW'}, 
			{name: 'Saint Helena', code: 'SH'}, 
			{name: 'Saint Kitts and Nevis', code: 'KN'}, 
			{name: 'Saint Lucia', code: 'LC'}, 
			{name: 'Saint Pierre and Miquelon', code: 'PM'}, 
			{name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
			{name: 'Samoa', code: 'WS'}, 
			{name: 'San Marino', code: 'SM'}, 
			{name: 'Sao Tome and Principe', code: 'ST'}, 
			{name: 'Saudi Arabia', code: 'SA'}, 
			{name: 'Senegal', code: 'SN'}, 
			{name: 'Serbia and Montenegro', code: 'CS'}, 
			{name: 'Seychelles', code: 'SC'}, 
			{name: 'Sierra Leone', code: 'SL'}, 
			{name: 'Singapore', code: 'SG'}, 
			{name: 'Slovakia', code: 'SK'}, 
			{name: 'Slovenia', code: 'SI'}, 
			{name: 'Solomon Islands', code: 'SB'}, 
			{name: 'Somalia', code: 'SO'}, 
			{name: 'South Africa', code: 'ZA'}, 
			{name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
			{name: 'Spain', code: 'ES'}, 
			{name: 'Sri Lanka', code: 'LK'}, 
			{name: 'Sudan', code: 'SD'}, 
			{name: 'Suriname', code: 'SR'}, 
			{name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
			{name: 'Swaziland', code: 'SZ'}, 
			{name: 'Sweden', code: 'SE'}, 
			{name: 'Switzerland', code: 'CH'}, 
			{name: 'Syrian Arab Republic', code: 'SY'}, 
			{name: 'Taiwan, Province of China', code: 'TW'}, 
			{name: 'Tajikistan', code: 'TJ'}, 
			{name: 'Tanzania, United Republic of', code: 'TZ'}, 
			{name: 'Thailand', code: 'TH'}, 
			{name: 'Timor-Leste', code: 'TL'}, 
			{name: 'Togo', code: 'TG'}, 
			{name: 'Tokelau', code: 'TK'}, 
			{name: 'Tonga', code: 'TO'}, 
			{name: 'Trinidad and Tobago', code: 'TT'}, 
			{name: 'Tunisia', code: 'TN'}, 
			{name: 'Turkey', code: 'TR'}, 
			{name: 'Turkmenistan', code: 'TM'}, 
			{name: 'Turks and Caicos Islands', code: 'TC'}, 
			{name: 'Tuvalu', code: 'TV'}, 
			{name: 'Uganda', code: 'UG'}, 
			{name: 'Ukraine', code: 'UA'}, 
			{name: 'United Arab Emirates', code: 'AE'}, 
			{name: 'United Kingdom', code: 'GB'}, 
			{name: 'United States', code: 'US'}, 
			{name: 'United States Minor Outlying Islands', code: 'UM'}, 
			{name: 'Uruguay', code: 'UY'}, 
			{name: 'Uzbekistan', code: 'UZ'}, 
			{name: 'Vanuatu', code: 'VU'}, 
			{name: 'Venezuela', code: 'VE'}, 
			{name: 'Viet Nam', code: 'VN'}, 
			{name: 'Virgin Islands, British', code: 'VG'}, 
			{name: 'Virgin Islands, U.S.', code: 'VI'}, 
			{name: 'Wallis and Futuna', code: 'WF'}, 
			{name: 'Western Sahara', code: 'EH'}, 
			{name: 'Yemen', code: 'YE'}, 
			{name: 'Zambia', code: 'ZM'}, 
			{name: 'Zimbabwe', code: 'ZW'} 
		])

		const bg_image = require('@/assets/themes/assets/media/bg/bg-2.jpg')

		const sidebar_image = [
			require('@/assets/agreement.jpg'),
			require('@/assets/onboard-sidebar-image.jpg'),
			require('@/assets/review-submit.jpg'),
			''
		]

		const state = reactive({
			subscription_date: '',
			annual_subscription: '',
			name: '',
			website: '',
			school_email: '',
			street_address: '',
			suburb: '',
			city: '',
			state: '',
			zip: '',
			country: '',
			contact_name: '',
			position: '',
			work_phone: '',
			mobile_phone: '',
			email: ''
		})
     
		const rules = {
				name: { required },
				website: { required },
				school_email: { required, email },
				street_address: { required },
				suburb: { required },
				city: { required },
				state: { required },
				zip: { required },
				country: { required },
				contact_name: { required },
				position: { required },
				work_phone: { required },
				mobile_phone: { required },
				email: { required, email }
		}

        const v$ = useVuelidate(rules, state);

        function addClass() {
            classList.value++
        }

		function isValid(v) {
        	return (v.$invalid && submitted.value) || v.$pending.$response
      	}
      
        function getError(v, label) {
        	return v.required.$message.replace('Value', label)
        }

		const handleSubmit = (isFormValid) => {
			if (agree.value)
			{
				if (step.value > 1) submitted.value = true

				if (step.value == 1) step.value++

				if (isFormValid) {
					if (step.value == 3) {
						submit()
					}
					else step.value++
				}
				if (!isFormValid) {
					if (step.value > 1)
						return;
				}
			}
			else
			{
				isAgreementNext.value = true
			}
        }

		async function submit() {
            const loadingInstance = ElLoading.service({ fullscreen: true })

			await submitOnboarding(formData.value)
			step.value++
			loadingInstance.close()
		}

        function getState(s) {

            if (step.value == s)
            {
                if (step.value == s)
                    return 'current'
                else if (step.value > 1)
                    return 'pending'
                else 
                    return 'current'
            }
            else {
                
                if (s > step.value)
                    return 'pending'
                else 
                    return 'done'
            }
        }

        function removeClass() {
            if (classList.value > 1)
                classList.value--
        }

        return {
            step,
            classList,
            addClass,
            removeClass,
            getState,
			v$,
			submitted,
			isValid,
			getError,
			handleSubmit,
			state,
			formData,
			countryList,
			agree,
			isAgreementNext,
			bg_image,
			sidebar_image
        }
    },
})
</script>
